// extracted by mini-css-extract-plugin
module.exports =  {"phones":"a10a3f92e9--phones--rw4_q"};